import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead } from "@/lib/seo";
import { SecurityPage } from "@/pages/beveiliging";

export const Route = createFileRoute("/beveiliging")({
  head: () => {
    const t = i18n.getFixedT("nl", "security");
    return pageHead({ lang: "nl", pathWithoutLang: "/beveiliging", title: t("seo.title"), description: t("seo.description") });
  },
  component: SecurityPage,
});
